<div class="wrapper-header">
    <mat-toolbar class="printos-header" id="printos-nav-header">
        <mat-toolbar-row>

        <div class="nav-wrapper">
              <div class="app-logo">
                  <div class="logo-text">
                      <a (click)="naviagteToHome()" rel="noopener">Home</a>
                  </div>
              </div>
          </div>
            <span class="example-spacer"></span>

            <span class="example-spacer"></span>

            <div class="customer-info">
              <p *ngIf="userName">{{userName}}</p>
               <div class="coverage-scroll">
                <p *ngIf="currentRole" class="coverage-areas">{{ currentRole}}</p>
               </div>
            </div>

        </mat-toolbar-row>
      </mat-toolbar>

</div>

